import React from 'react';

const PendingSheetsEmployee = () => {
    return (
        <div style={{ fontFamily: "Arial, sans-serif", padding: "20px" }}>
            <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                Why is my timesheet still pending?
            </h3>
            <p style={{ fontSize: "16px", color: "#333", lineHeight: "1.5" }}>
                This section displays timesheets that are currently in a pending state. When an employee submits a timesheet, it enters the pending state until approved by the approval manager or super admin. 
                Review and take the necessary actions promptly to avoid delays.
            </p>

            <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#444", marginTop: "20px" }}>Pending Sheets Overview</h4>
            <p style={{ fontSize: "16px", color: "#333", lineHeight: "1.5" }}>
                The pending sheets section contains all timesheets that are awaiting approval. Employees can track their submitted timesheets, view approval status, and check for any comments provided by approvers.
            </p>

            <img
                style={{ width: "60%", borderRadius: "8px", marginTop: "10px" }}
                src="https://res.cloudinary.com/danfpnuui/image/upload/v1737352972/Pending_sheets-1_zgdv7g.png"
                alt="Pending Sheets Screenshot"
            />

            <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#444", marginTop: "20px" }}>Steps to Submit Your Timesheet</h4>
            <ol style={{ fontSize: "16px", color: "#333", lineHeight: "1.5", paddingLeft: "20px" }}>
                <li> Click the <b>&lt;Sheets</b> and <b>&lt;Select</b> the sheet you want to review.</li>
                <li> Click on the timesheet to open it.</li>
                <li> Enter the remaining billable hours and attach any necessary documents.</li>
                <li> Click the submit button to finalize the timesheet submission.</li>
            </ol>

            <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#444", marginTop: "20px" }}>Important Notes:</h4>
            <ul style={{ fontSize: "16px", color: "#333", lineHeight: "1.5", paddingLeft: "20px" }}>
                <li>Timesheets where billable hours are entered daily will be saved under <i>Pending Sheets</i> until final submission.</li>
            </ul>

            <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#444", marginTop: "20px" }}>Tip:</h4>
            <p style={{ fontSize: "16px", color: "#333", lineHeight: "1.5" }}>
                If you enter billable hours, remember to click the <b>Save</b> button. If you need to correct any billable hours or attachments, you can edit and re-enter the data before submission.
            </p>
        </div>
    );
};

export default PendingSheetsEmployee;
